var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center py-2 px-3",style:({
  backgroundColor: '#1d5166',
  color: 'white',
  zIndex: 5,
  fontSize: `${_vm.$vuetify.breakpoint.xs || _vm.$vuetify.breakpoint.sm ? 14 : 16}px`
}),attrs:{"cols":"12"}},[(_vm.$vuetify.breakpoint.xs || _vm.$vuetify.breakpoint.sm)?[_vm._v("\n    "+_vm._s(_vm.$t(`countdown_mobile_text${_vm.campaign.isLottery ? '_lottery' : ''}`, {
      countdown: `${Math.floor(_vm.timer / 60)}:${(_vm.timer % 60).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false
      })}`
    }))+"\n  ")]:[_vm._v("\n    "+_vm._s(_vm.$t(`countdown_desktop_text${_vm.campaign.isLottery ? '_lottery' : ''}`, {
      countdown: `${Math.floor(_vm.timer / 60)}:${(_vm.timer % 60).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false
      })}`
    }))+"\n  ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }